export const KW_CUSTOMER = 'kw-customer';
export const LIST_REPORTS_CUSTOMER = 'list-reports-customer';
export const REDFIN_CUSTOMER = 'redfin-customer';